module.exports = __webpack_public_path__ + "static/media/Film.d6b38039.svg";